import React from "react";

function TableRow({ item }) {
  const {
    solutionName,
    CommonInfo,
    CommonInfo2,
    CommonInfo4,
    ConnectionCold,
    ConnectionHot,
  } = item;
  return (
    <tr className="table-row">
      <td>{solutionName ? solutionName : null}</td>
      <td>
        {CommonInfo ? CommonInfo : CommonInfo2 ? CommonInfo2 : CommonInfo4}
      </td>
      <td>{ConnectionCold ? ConnectionCold : null}</td>
      <td>{ConnectionHot ? ConnectionHot : null}</td>
    </tr>
  );
}

export default TableRow;
